// components/HomePage/components/Coach/index.js
import CoachCallStrength from "./CoachCallStrength";

export const coachRegistry = {
  coach_session: CoachCallStrength,
  // future: group_session, coach_feedback, reflection_prompt, etc.
};
